import styled from '@emotion/styled';

import { maxWidthAndCenter, button } from '@styles';

import { ICallsToActionProps } from '.';

type TStyleOverrides = {} & Pick<ICallsToActionProps, 'cssOverrides'>;

const CallsToActionContainer = styled.div<TStyleOverrides>`
  ${(props) => props.cssOverrides}

  .calls_to_action__wrap {
    ${maxWidthAndCenter}
    display: flex;
    justify-content: center;

    &.calls_to_action__wrap--vertical {
      flex-direction: column-reverse;

      a:nth-of-type(2) {
        margin: 0 0 0.75rem 0;
      }
    }

    &.calls_to_action__wrap--horizontal {
      flex-direction: row;

      a {
        width: 100%;
        max-width: 25rem;
      }

      a:first-of-type {
        margin: 0 2rem 0 0;
      }
    }
  }

  .calls_to_action__span--light {
    font-weight: 300;
  }

  .calls_to_action__phone {
    ${button('blue')}
  }

  .calls_to_action__fallback,
  .calls_to_action__email {
    ${button('orange')}
  }

  @media screen and (max-width: 1152px) {
    padding: 0 2rem 4rem;

    .calls_to_action__wrap {
      align-items: center;

      .calls_to_action__phone,
      .calls_to_action__email {
        padding: 0.75rem 2.75rem;
      }

      &.calls_to_action__wrap--horizontal {
        flex-direction: column;
        align-items: center;

        a:nth-of-type(1) {
          margin: 0 0 0.75rem 0;
        }

        a:nth-of-type(2) {
          margin: 0;
        }
      }
    }
  }
`;

export { CallsToActionContainer };
